import { supabase } from "@/lib/supabase";

export interface StorySubmissionInput {
  submitter_name: string;
  email: string;
  phone?: string;
  village?: string;
  title: string;
  category?: string;
  story: string;
}

/**
 * Saves a visitor's story to the backend as a pending submission. Submitted
 * anonymously, so it is inserted without reading the row back (the public role
 * has insert-only access; the team reviews it in the admin).
 */
export async function submitStory(input: StorySubmissionInput): Promise<void> {
  const { error } = await supabase.from("story_submissions").insert({
    submitter_name: input.submitter_name.trim(),
    email: input.email.trim(),
    phone: input.phone?.trim() || null,
    village: input.village?.trim() || null,
    title: input.title.trim(),
    category: input.category?.trim() || null,
    story: input.story.trim(),
    status: "pending",
  });
  if (error) throw error;
}